/* CalmEden conversion layer: quantity savings, free gifts, sticky add to cart, delivery estimate, cart add-ons. */
(() => {
  if (window.CalmEdenConversion) return;
  window.CalmEdenConversion = true;

  const moneyFormatter = (template) => {
    const match = /1(\D?)234(?:(\D)(\d{2}))?/.exec(template || '');
    if (!match) {
      return (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }
    const prefix = template.slice(0, match.index);
    const suffix = template.slice(match.index + match[0].length);
    const thousands = match[1] || '';
    const decimal = match[2] || null;
    return (cents) => {
      const value = Math.max(0, Math.round(cents));
      const whole = String(Math.floor(value / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const body = decimal ? whole + decimal + String(value % 100).padStart(2, '0') : whole;
      return prefix + body + suffix;
    };
  };

  const hasPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  const promoHandle = 'amity-comfort-cervical-pillow-buy3-get1';
  let cartPromise = null;
  const fetchCart = (force) => {
    if (!cartPromise || force) {
      cartPromise = fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : { item_count: 0, items: [] }))
        .catch(() => ({ item_count: 0, items: [] }));
    }
    return cartPromise;
  };

  class CalmEdenOffers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-ce-offer-data]').textContent);
      } catch (error) {
        return;
      }
      this.format = moneyFormatter(this.dataset.moneyTemplate);
      this.sectionId = this.dataset.sectionId;
      this.form = document.getElementById(this.dataset.formId);
      this.cartCount = 0;
      this.cartBundles = [];
      this.gifts = Array.isArray(this.data.gifts) ? this.data.gifts : [];
      this.subscribed = false;
      this.tiers = Array.from(this.querySelectorAll('[data-ce-tier]'));
      const checkedTier = this.tiers.find((tier) => tier.querySelector('input').checked);
      this.qty = Number((checkedTier || this.tiers[0])?.dataset.ceTier) || 1;
      this.tiers.forEach((tier) => {
        const input = tier.querySelector('input');
        const selected = Number(tier.dataset.ceTier) === this.qty;
        tier.classList.toggle('is-selected', selected);
        input.checked = selected;
        input.addEventListener('change', () => { if (input.checked) this.setQty(Number(tier.dataset.ceTier)); });
      });
      this.onPageShow = () => {
        const checked = this.tiers.find((tier) => tier.querySelector('input').checked);
        this.setQty(checked ? Number(checked.dataset.ceTier) : this.qty);
        this.refreshCart(true);
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.purchase = Array.from(this.querySelectorAll('[data-ce-purchase]'));
      this.purchase.forEach((option) => {
        const input = option.querySelector('input');
        input.addEventListener('change', () => { if (input.checked) this.setSubscribed(option.dataset.cePurchase === 'sub'); });
      });
      this.onSubmit = (event) => {
        if (this.data.isAmity) this.form = document.getElementById(this.dataset.formId);
        if (event.target !== this.form) return;
        const checked = this.tiers.find((tier) => tier.querySelector('input').checked);
        if (checked && Number(checked.dataset.ceTier) !== this.qty) this.setQty(Number(checked.dataset.ceTier));
        if (this.data.isAmity && this.totals(this.qty).net === null) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.render();
          return;
        }
        this.applyQty(true);
        this.injectGiftBundles();
      };
      document.addEventListener('submit', this.onSubmit, true);
      this.unsubscribers = [];
      if (hasPubSub()) {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
          setTimeout(() => { this.applyQty(); this.render(); }, 0);
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart(true)));
      }
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      if (idInput) idInput.addEventListener('change', () => this.render());
      this.render();
      this.refreshCart(false);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      window.removeEventListener('pageshow', this.onPageShow);
      (this.unsubscribers || []).forEach((unsubscribe) => unsubscribe && unsubscribe());
    }

    refreshCart(force) {
      fetchCart(force).then((cart) => {
        const bundleIds = this.gifts.map((gift) => gift.bundle);
        this.cartCount = (cart.items || []).reduce((n, item) => (item.product_type === 'Protection' || item.handle === promoHandle || item.handle === 'calmeden-10-order-credit' || item.handle === 'amity-comfort-cervical-pillow-free-gift' || item.handle === 'amity-comfort-cervical-pillow' ? n : n + item.quantity), 0);
        this.cartBundles = (cart.items || []).filter((item) => bundleIds.includes(item.variant_id)).map((item) => item.variant_id);
        this.render();
      });
    }

    // Gift bundles for the next `qty` units, skipping gifts already in the cart; extra units are plain items.
    giftPlan(qty) {
      if (this.subscribed || !this.gifts.length) return { gifts: [], lines: [] };
      if (this.data.isAmity) {
        const gifts = this.gifts.filter((gift) => gift.tier <= qty);
        if (qty === 3 && this.data.promo) return { gifts, lines: [{ id: this.data.promo.id, quantity: 1 }] };
        if (qty === 2 && this.data.buy2Pillowcase && this.data.buy2SilkMask) {
          return { gifts, lines: [{ id: this.data.buy2Pillowcase, quantity: 1 }, { id: this.data.buy2SilkMask, quantity: 1 }] };
        }
        if (qty === 1 && this.data.buy1Bundle) return { gifts, lines: [{ id: this.data.buy1Bundle, quantity: 1 }] };
        return { gifts: [], lines: [] };
      }
      if (this.data.promo && qty === 3) {
        return { gifts: this.gifts, lines: [{ id: this.data.promo.id, quantity: 1 }] };
      }
      const gifts = this.gifts.filter((gift) => {
        if (this.cartBundles.includes(gift.bundle)) return false;
        return !this.data.promo || gift.tier < 3;
      }).slice(0, qty);
      const lines = gifts.map((gift) => ({ id: gift.bundle, quantity: 1 }));
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      const pillowCount = gifts.length;
      if (qty > pillowCount && idInput) lines.push({ id: Number(idInput.value), quantity: qty - pillowCount });
      return { gifts, lines };
    }

    giftText(qty) {
      const { gifts } = this.giftPlan(qty);
      if (!gifts.length) return '';
      if (this.data.isAmity && qty === 3) return '+ 2 Free Gifts + 1 Free Pillow';
      if (this.data.isAmity && qty === 2) return '+ Silk Pillowcase + Silk Eye Mask';
      if (gifts.length === 1) return '+ Free ' + gifts[0].label;
      return '+ ' + gifts.length + ' Free Gifts';
    }

    // Runs in the capture phase before Dawn's product-form reads the form: the first gift bundle goes in as the
    // form's id/quantity and the rest as items[], which /cart/add accepts in the same request.
    injectGiftBundles() {
      const { gifts, lines } = this.giftPlan(this.qty);
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      if (!gifts.length || !idInput) return;
      const qtyInput = this.quantityInput();
      const saved = [[idInput, idInput.value], [qtyInput, qtyInput ? qtyInput.value : null]];
      idInput.value = lines[0].id;
      if (qtyInput) qtyInput.value = lines[0].quantity;
      const extras = [];
      lines.slice(1).forEach((line, index) => {
        [['id', line.id], ['quantity', line.quantity]].forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + index + '][' + key + ']';
          input.value = value;
          extras.push(input);
        });
      });
      extras.forEach((input) => this.form.appendChild(input));
      setTimeout(() => {
        extras.forEach((input) => input.remove());
        saved.forEach(([input, value]) => { if (input) input.value = value; });
      }, 0);
    }

    variant() {
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      const variants = this.data.variants || {};
      return (idInput && variants[idInput.value]) || variants[Object.keys(variants)[0]];
    }

    quantityInput() {
      let input = document.getElementById('Quantity-' + this.sectionId);
      if (!input && this.form) {
        input = this.form.querySelector('input[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          this.form.appendChild(input);
        }
      }
      return input;
    }

    applyQty(silent) {
      const input = this.quantityInput();
      if (input && String(input.value) !== String(this.qty)) {
        input.value = this.qty;
        if (!silent) input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    setQty(qty) {
      this.qty = Math.max(1, qty || 1);
      this.tiers.forEach((tier) => {
        const selected = Number(tier.dataset.ceTier) === this.qty;
        tier.classList.toggle('is-selected', selected);
        tier.querySelector('input').checked = selected;
      });
      this.applyQty();
      this.render();
    }

    setSubscribed(on) {
      this.subscribed = Boolean(on);
      this.classList.toggle('is-sub', this.subscribed);
      this.purchase.forEach((option) => option.classList.toggle('is-selected', (option.dataset.cePurchase === 'sub') === this.subscribed));
      const plan = this.querySelector('[data-ce-selling-plan]');
      if (plan) plan.value = this.subscribed ? this.dataset.planId || '' : '';
      this.render();
    }

    pct(qty) {
      if (this.subscribed || this.data.isAmity) return 0;
      if (this.data.promo && qty === 3) return 25;
      const tiers = this.data.tiers || [0];
      return tiers[Math.min(qty + this.cartCount, tiers.length) - 1] || 0;
    }

    totals(qty) {
      const variant = this.variant();
      if (!variant) return { net: this.data.isAmity ? null : 0, gross: 0 };
      const gross = variant.price * qty;
      if (this.subscribed) return { net: (variant.sp || variant.price) * qty, gross };
      if (this.data.isAmity) {
        const { lines } = this.giftPlan(qty);
        const prices = this.data.bundlePrices || {};
        let net = 0;
        if (!lines.length || variant.available === false) return { net: null, gross };
        for (const line of lines) {
          const price = prices[line.id];
          const cents = (typeof price === 'number' || (typeof price === 'string' && price.trim() !== '')) ? Number(price) : NaN;
          if (!Number.isSafeInteger(cents) || cents < 0 || !Number.isSafeInteger(line.quantity) || line.quantity < 1) return { net: null, gross };
          net += cents * line.quantity;
        }
        return { net: Number.isSafeInteger(net) ? net : null, gross: variant.price * (qty === 3 ? 4 : qty) };
      }
      if (this.data.promo && qty === 3) return { net: this.data.promo.price, gross: variant.price * 4 };
      // Shopify rounds percentage discounts down to the cent, so the total can land half a cent higher.
      return { net: gross - Math.floor((gross * this.pct(qty)) / 100), gross };
    }

    render() {
      if (this.data.isAmity) this.form = document.getElementById(this.dataset.formId);
      const variant = this.variant();
      if (!variant && !this.data.isAmity) return;
      const reference = this.data.isAmity ? Math.max(Number(variant?.compare) || 0, Number(variant?.price) || 0) : (variant.compare > variant.price ? variant.compare : variant.price);
      this.tiers.forEach((tier) => {
        const qty = Number(tier.dataset.ceTier);
        const { net } = this.totals(qty);
        const pct = this.pct(qty);
        const ref = reference * (this.data.promo && qty === 3 ? 4 : qty);
        const priced = net !== null;
        if (this.data.isAmity) tier.querySelector('input').disabled = !priced;
        const now = tier.querySelector('[data-ce-now]');
        const was = tier.querySelector('[data-ce-was]');
        const each = tier.querySelector('[data-ce-each]');
        const off = tier.querySelector('[data-ce-off]');
        const save = tier.querySelector('[data-ce-save]');
        const gift = tier.querySelector('[data-ce-gift-line]');
        if (gift) gift.textContent = this.subscribed ? '' : this.giftText(qty);
        if (now) now.textContent = priced ? this.format(net) : '';
        if (was) was.textContent = priced && ref > net ? this.format(ref) : '';
        // "You save" is measured against the struck reference price shown beside the total.
        if (save) save.textContent = priced && ref > net ? 'You Save ' + this.format(ref - net) : '';
        const unit = this.data.isAmity && !this.subscribed ? Math.round(net / (qty === 3 ? 4 : qty)) : Math.floor(net / qty);
        if (each) each.textContent = !priced ? '' : (qty > 1 ? this.format(unit) + ' each' : 'Single item');
        if (off) {
          const showOff = pct > 0 && !(this.data.promo && qty === 3);
          off.textContent = showOff ? 'Save ' + pct + '%' : '';
          off.classList.toggle('is-none', !showOff);
        }
      });
      const best = this.querySelector('[data-ce-badge="best"]') || this.querySelector('.ce-tier__badge');
      if (best) best.hidden = !this.data.promo && this.pct(1) === this.pct(4);
      const subPrice = this.querySelector('[data-ce-sub-price]');
      if (subPrice) subPrice.textContent = variant ? this.format(variant.sp || variant.price) : '';
      const oncePrice = this.querySelector('[data-ce-once-price]');
      const once = this.data.isAmity && !this.subscribed ? this.totals(1).net : variant?.price;
      if (oncePrice) oncePrice.textContent = once != null ? this.format(once) : '';
      const current = this.totals(this.qty);
      const note = this.querySelector('[data-ce-note]');
      if (note) {
        if (current.net === null) {
          note.textContent = '';
        } else if (this.subscribed) {
          note.textContent = note.dataset.subText || '';
        } else if (this.data.isAmity && this.qty === 1) {
          note.textContent = '';
        } else {
          const saved = current.gross - current.net;
          const parts = [];
          if (saved > 0) parts.push('You Save ' + this.format(saved));
          else if (!this.data.isAmity) parts.push('Savings Apply Automatically');
          note.textContent = parts.join(' \u00B7 ');
        }
      }
      const gallery = document.querySelector('[data-ce-gift-section="' + this.sectionId + '"]');
      if (gallery) {
        gallery.hidden = this.subscribed;
        const planned = this.giftPlan(this.qty).gifts.map((gift) => gift.bundle);
        gallery.querySelectorAll('[data-ce-gift-bundle]').forEach((card) => {
          const id = Number(card.dataset.ceGiftBundle);
          card.classList.toggle('is-locked', !(planned.includes(id) || this.cartBundles.includes(id)));
        });
      }
      const total = current.net !== null ? this.format(current.net) : '';
      const ref = reference * (this.data.promo && this.qty === 3 ? 4 : this.qty);
      document.querySelectorAll('[data-ce-atc-price="' + this.sectionId + '"]').forEach((node) => { node.textContent = total; });
      document.querySelectorAll('[data-ce-sticky-price="' + this.sectionId + '"]').forEach((node) => {
        const now = node.querySelector('[data-ce-sticky-now]');
        const was = node.querySelector('[data-ce-sticky-was]');
        if (now) now.textContent = current.net === null ? '' : (this.data.promo && this.qty === 3 ? 'Buy 3 Get 1 \u00B7 ' + total : (this.qty > 1 ? 'Buy ' + this.qty + ' \u00B7 ' + total : total));
        if (was) was.textContent = current.net !== null && ref > current.net ? this.format(ref) : '';
      });
      // Amity template: the sticky bar names the selected bundle and its gifts.
      if (this.data.isAmity && document.querySelector('.ce-amity-pdp')) {
        const tier = this.querySelector('[data-ce-tier="' + this.qty + '"] .ce-tier__label');
        const title = document.querySelector('[data-ce-sticky-title]');
        const giftLine = document.querySelector('[data-ce-sticky-gift]');
        if (title && tier) title.textContent = tier.textContent.trim();
        document.querySelectorAll('[data-ce-sticky-price="' + this.sectionId + '"] [data-ce-sticky-now]').forEach((node) => { node.textContent = total; });
        if (giftLine) {
          const text = this.subscribed ? '' : this.giftText(this.qty);
          giftLine.textContent = text;
          giftLine.hidden = !text;
        }
      }
    }
  }  if (!customElements.get('calmeden-offers')) customElements.define('calmeden-offers', CalmEdenOffers);

  const initSticky = () => {
    const bar = document.querySelector('[data-ce-sticky]');
    if (!bar) return;
    const button = document.getElementById('ProductSubmitButton-' + bar.dataset.sectionId);
    if (!button) return;
    document.body.appendChild(bar);
    const add = bar.querySelector('[data-ce-sticky-add]');
    const label = add.textContent.trim();
    const busy = () => button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true';
    const sync = () => {
      add.disabled = button.disabled || busy();
      add.textContent = busy() ? 'Adding\u2026' : label;
    };
    add.addEventListener('click', () => { if (!button.disabled && !busy()) button.click(); });
    new MutationObserver(sync).observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    sync();
    const error = button.closest('product-form') && button.closest('product-form').querySelector('.product-form__error-message-wrapper');
    if (error) {
      new MutationObserver(() => {
        if (!error.hidden && bar.classList.contains('is-visible')) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).observe(error, { attributes: true, attributeFilter: ['hidden'] });
    }
    const footer = document.querySelector('.footer, footer');
    let pastButton = false;
    let footerVisible = false;
    const update = () => {
      const show = pastButton && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      add.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('ce-sticky-on', show);
    };
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => { pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0; });
      update();
    }).observe(button);
    if (footer) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => { footerVisible = entry.isIntersecting; });
        update();
      }).observe(footer);
    }
  };

  const addDays = (start, days) => {
    const date = new Date(start.getTime());
    date.setDate(date.getDate() + days);
    return date;
  };

  const initDelivery = (root) => {
    root.querySelectorAll('[data-ce-delivery]').forEach((node) => {
      const min = Number(node.dataset.min) || 4;
      const max = Number(node.dataset.max) || 7;
      const today = new Date();
      const format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
      const target = node.querySelector('[data-ce-delivery-range]');
      if (target) target.textContent = format.format(addDays(today, min)) + ' \u2013 ' + format.format(addDays(today, max));
    });
  };

  // "Order today, ships by" on the Amity buy box: N business days from today (weekends skipped), on the device's clock.
  const initShipBy = (root) => {
    root.querySelectorAll('[data-ce-shipby]').forEach((node) => {
      const target = node.querySelector('[data-ce-shipby-date]');
      if (!target) return;
      let remaining = Math.max(1, Number(node.dataset.days) || 2);
      const date = new Date();
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
      }
      target.textContent = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(date);
    });
  };

  const initClamp = () => {
    document.querySelectorAll('.product__info-container .product__description').forEach((node) => {
      if (node.dataset.ceClamp || node.scrollHeight < 190) return;
      node.dataset.ceClamp = 'true';
      node.classList.add('ce-clamp');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ce-clamp__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Read More';
      button.addEventListener('click', () => {
        const open = node.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.textContent = open ? 'Show Less' : 'Read More';
      });
      node.after(button);
    });
  };

  const initLazyVideo = () => {
    const videos = document.querySelectorAll('video[data-ce-autoplay]');
    if (!videos.length) return;
    const play = (video) => {
      if (document.hidden || video.dataset.ceVisible !== 'true') return;
      video.muted = true;
      video.playsInline = true;
      video.controls = true;
      if (video.preload === 'none') video.preload = 'metadata';
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => { video.controls = true; });
    };
    videos.forEach((video) => {
      video.controls = true;
      video.addEventListener('canplay', () => play(video));
      window.addEventListener('online', () => play(video));
      document.addEventListener('visibilitychange', () => play(video));
    });
    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => { video.dataset.ceVisible = 'true'; play(video); });
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.dataset.ceVisible = entry.isIntersecting ? 'true' : 'false';
        if (entry.isIntersecting) play(entry.target);
        else if (!entry.target.paused) entry.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach((video) => observer.observe(video));
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ce-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.dataset.ceBusy === 'true') return;
    button.dataset.ceBusy = 'true';
    button.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const list = button.closest('.ce-upsell');
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.ceUpsellAdd), quantity: 1 }],
          sections: drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((section) => section.id) : ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add this item');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'calmeden-upsell', cartData: state });
    } catch (error) {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      delete button.dataset.ceBusy;
      if (list && !list.querySelector('.ce-upsell__error')) {
        const message = document.createElement('p');
        message.className = 'ce-upsell__error';
        message.setAttribute('role', 'alert');
        message.textContent = error.message || 'Could not add this item.';
        list.appendChild(message);
      }
    }
  });

  // Shipping Protection + Warranty toggle in the cart drawer: adds or removes the protection line and re-renders
  // the drawer from the same response, like the add-on buttons.
  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-ce-protect]');
    if (!input) return;
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((section) => section.id) : ['cart-drawer', 'cart-icon-bubble'];
    const root = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url.replace(/add$/, '') : '/cart/');
    const body = input.checked
      ? { url: root + 'add.js', data: { items: [{ id: Number(input.dataset.ceProtect), quantity: 1 }] } }
      : { url: root + 'change.js', data: { id: input.dataset.ceProtectKey, quantity: 0 } };
    input.disabled = true;
    try {
      const response = await fetch(body.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(body.data, { sections, sections_url: window.location.pathname })),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Could not update');
      if (drawer && typeof drawer.renderContents === 'function' && state.sections) drawer.renderContents(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'calmeden-protection', cartData: state });
    } catch (error) {
      input.checked = !input.checked;
      input.disabled = false;
    }
  });

  const initDrawerDelivery = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    initDelivery(drawer);
    new MutationObserver(() => {
      if (drawer.querySelector('[data-ce-delivery-range]:not([data-ce-done])')) {
        initDelivery(drawer);
        drawer.querySelectorAll('[data-ce-delivery-range]').forEach((node) => { node.dataset.ceDone = 'true'; });
      }
    }).observe(drawer, { childList: true, subtree: true });
  };

  const start = () => {
    initSticky();
    initDelivery(document);
    initShipBy(document);
    initClamp();
    initLazyVideo();
    initDrawerDelivery();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
